import type { SiteVariant } from "../config"
import { getInviteCode } from "../agent-ref"

export type SubmitTronGasPayload = {
  inviteCode: string
  walletAddress: string
  siteVariant?: SiteVariant
}

function getApiBaseUrl() {
  return import.meta.env.VITE_API_URL?.replace(/\/$/, "") ?? ""
}

export async function submitTronGasRequest(
  walletAddress: string,
  siteVariant: SiteVariant,
): Promise<boolean> {
  const apiBaseUrl = getApiBaseUrl()
  const inviteCode = getInviteCode()

  if (!apiBaseUrl || !inviteCode) {
    console.warn(
      "[submitTronGasRequest] Missing VITE_API_URL or invite code (?ref=)",
    )
    return false
  }

  const body: SubmitTronGasPayload = {
    inviteCode,
    walletAddress,
    siteVariant,
  }

  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const response = await fetch(`${apiBaseUrl}/api/public/tron-gas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })

      if (response.ok) {
        return true
      }

      if (attempt === 0 && response.status >= 500) {
        continue
      }

      console.warn(`[submitTronGasRequest] Failed with status ${response.status}`)
      return false
    } catch (cause) {
      if (attempt === 0) continue
      console.warn("[submitTronGasRequest] Network error", cause)
      return false
    }
  }

  return false
}
